// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: connect Codex from Settings. A regular themed modal (the onboarding gate keeps
// its own dark look); on phones it is the centred card the other connect flows use.
import * as Modal from '@app/features/app/components/dialogs/Modal';
import {CANCEL_DESCRIPTOR} from '@app/features/i18n/utils/CommonMessageDescriptors';
import styles from '@app/features/konvo_connections/components/KonvoCodexConnectModal.module.css';
import {KonvoCodexSignIn} from '@app/features/konvo_connections/components/KonvoCodexSignIn';
import {Button} from '@app/features/ui/button/Button';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {OpenAILogo} from '@app/features/ui/components/icons/OpenAILogo';
import {CheckCircleIcon} from '@app/features/ui/icons/Icons';
import {msg} from '@lingui/core/macro';
import {Trans, useLingui} from '@lingui/react/macro';
import {useState} from 'react';

const KEY = 'konvo-codex-connect';
function KonvoCodexConnectModal() {
	const {i18n} = useLingui();
	const [connected, setConnected] = useState(false);
	const close = () => ModalCommands.popWithKey(KEY);
	return (
		<Modal.Root size="small" centered onClose={close} data-flx="konvo-codex-connect.root">
			<Modal.Header title={i18n._(msg`Connect Codex`)} onClose={close} data-flx="konvo-codex-connect.header" />
			<Modal.Content data-flx="konvo-codex-connect.content">
				<div className={styles.content}>
					<div className={styles.hero}>
						<span className={styles.tile}>
							{connected ? (
								<CheckCircleIcon size={26} weight="fill" className={styles.done} />
							) : (
								<OpenAILogo size={26} />
							)}
						</span>
						<div className={styles.heroText}>
							<p className={styles.title}>
								{connected ? <Trans>Codex is connected.</Trans> : <Trans>Meet your new assistant.</Trans>}
							</p>
							<p className={styles.lead}>
								{connected ? (
									<Trans>Codex now powers your Konvo Assistant. Claude won’t answer while Codex is selected.</Trans>
								) : (
									<Trans>Connect your ChatGPT account to power your Konvo Assistant with Codex.</Trans>
								)}
							</p>
						</div>
					</div>
					{!connected && <KonvoCodexSignIn onConnected={() => setConnected(true)} />}
				</div>
			</Modal.Content>
			<Modal.Footer data-flx="konvo-codex-connect.footer">
				{connected ? (
					<Button onClick={close} data-flx="konvo-codex-connect.done">
						<Trans>Done</Trans>
					</Button>
				) : (
					<Button variant="secondary" onClick={close} data-flx="konvo-codex-connect.cancel">
						{i18n._(CANCEL_DESCRIPTOR)}
					</Button>
				)}
			</Modal.Footer>
		</Modal.Root>
	);
}
export function openKonvoCodexConnectModal() {
	ModalCommands.pushWithKey(
		ModalCommands.modal(() => <KonvoCodexConnectModal />),
		KEY,
	);
}
